import Modal from "components/atoms/modal";
import { H4, TextSm } from "components/atoms/text";
import Btn from "components/atoms/buttons";

interface Props {
  onClose: () => void;
  onDelete: () => void;
}

// 삭제 안내 모달
const ModalDelete = ({ onClose, onDelete }: Props) => {
  const handleDelete = () => {
    onDelete();
    onClose();
  };

  return (
    <Modal.Container className="w-[312px] p-10 rounded-16 text-center">
      <H4 className="mb-3">삭제</H4>
      <TextSm>정말로 삭제 하시겠습니까?</TextSm>
      <div className="flex gap-5 mt-9">
        <Btn.Gray onClick={onClose} size="large" className="flex-1">
          취소
        </Btn.Gray>
        <Btn.Red onClick={handleDelete} size="large" className="flex-1">
          삭제
        </Btn.Red>
      </div>
    </Modal.Container>
  );
};

export default ModalDelete;
